const getStartTime = (url: URL): number | undefined => {
  const startParam = url.searchParams.get('t') || url.searchParams.get('start')

  if (!startParam) {
    return undefined
  }

  // Parse formats like "90" or "1h2m3s"
  if (/^\d+$/.test(startParam)) return parseInt(startParam, 10)

  const h = /(\d+)h/.exec(startParam)?.[1]
  const m = /(\d+)m/.exec(startParam)?.[1]
  const s = /(\d+)s/.exec(startParam)?.[1]
  const seconds = (h ? +h * 3600 : 0) + (m ? +m * 60 : 0) + (s ? +s : 0)

  return seconds || undefined
}

export default getStartTime
